import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  TextField,
  Button,
  Chip,
  Box,
  IconButton,
  Typography,
  Avatar,
  Autocomplete,
  Popper,
  InputAdornment,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Switch,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import "./Postcreation.css";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import StarIcon from "@mui/icons-material/Star";
import LinkIcon from "@mui/icons-material/Link";
import coins from "../../../assets/Profile-coins.svg";
import message from "../../../assets/Posts.svg";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import SearchIcon from "@mui/icons-material/Search";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import {
  createPost,
  preparePost,
  uploadMedia,
  updatePostContent,
  postDetailsByPostId,
} from "../../../services/postService";
import EditorBox from "./Editor";
import ImageLibraryModal from "./ImageUploader";
import VideoLibraryModal from "./videoUploader";
import SharePostPopup from "../../sharePostPopup/SharePostPopup";
import ActivitiesPopup from "../../activities/ActivitiesPopup";
import LoaderOverlay from "./loaderOverLay";
import StatusPopup from "./StatusPopup";
import { toast } from "react-toastify";
import { Auth } from "../../../contexts/AuthContext";
import {
  employeeTrendingListing,
  employeeTrendingTopics,
  employeeUserListing,
  fetchOrgTrendingTopics,
  globalTrendingTopics,
} from "../../../services/adminServices";
import { Content_Generation } from "../../../services/ai_post_generation";
import {
  clampPlatformContent,
  composePlatformContent,
  isPayoneerDomain,
  stripHashtagsFromText,
} from "../../../shared/businessPageComposer";
import UserService from "../../../services/categoryService";
const TextEditor = ({ userProfile, onPostCreated, editPost = null, onEditSuccess, onEditCancel }) => {
  const editPostId = editPost?.id || null;
  const isEditMode = !!editPostId;
  const [postText, setPostText] = useState("");
  const [categories, setCategories] = useState([]);
  const [categoriesIds, setCategoriesIds] = useState([]);
  const [postReview, setPostReview] = useState(false);
  const [activities, setActivities] = useState(false);
  const [categoryInput, setCategoryInput] = useState("");
  const [trendsInput, setTrendsInput] = useState("");
  const [videos, setVideos] = useState([]);
  const [openVideoModal, setOpenVideoModal] = useState(false);
  const [taggedMembers, setTaggedMembers] = useState([]);
  const [taggedMemberInput, setTaggedMemberInput] = useState("");
  const [taggedMemberIds, setTaggedMemberIds] = useState([]);
  const [isTaggingVisible, setIsTaggingVisible] = useState(false);
  const [activeButton, setActiveButton] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [postData, setPostData] = useState(null);
  const [userData, setUsersData] = useState([]);
  const [trendsData, setTrendsData] = useState([]);
  const [orgTrendsData, setOrgTrendsData] = useState([]);
  const [personalTrendsData, setPersonalTrendsData] = useState([]);
  const [trendingTopicType, setTrendingTopicType] = useState('org');

  useEffect(() => {
    setTrendsData(trendingTopicType === 'org' ? orgTrendsData : personalTrendsData);
  }, [trendingTopicType, orgTrendsData, personalTrendsData]);
  const [LoggedInUser, setLoggedInUser] = useState(null);
  const [discard, setDiscard] = useState(false);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("");
  const [images, setImages] = useState([]);
  const { loyaltyPoints, categoriesData, setCategoriesData, businessPages } = Auth();
  const [categoryCreating, setCategoryCreating] = useState(false);
  const [categoryError, setCategoryError] = useState(false);
  const [addCategoryDialogOpen, setAddCategoryDialogOpen] = useState(false);
  const [newCategoryDialogInput, setNewCategoryDialogInput] = useState("");
  const [allowEdit, setAllowEdit] = useState(false);
  const [featuredUrl, setFeaturedUrl] = useState("");
  const isAdmin = JSON.parse(sessionStorage.getItem("role") || "[]")
    .flat().includes("ROLE_ADMIN");
  const hasFeatured = categories.some((c) => c.name?.toLowerCase() === "featured");
  const [uploadedImageIds, setUploadedImageIds] = useState([]);
  const [uploadLibraryId, setUploadLibraryId] = useState([]);
  const [attachedFiles, setAttachedFiles] = useState([]);
  const [selectedTrends, setSelectedTrends] = useState([]);
  const [selectedTrendingTopic, setSelectedTrendingTopic] = useState("");
  
  // Variations state
  const [variations, setVariations] = useState([
    { editorValue: "", images: [], videos: [], attachedFiles: [], uploadedImageIds: [], uploadLibraryId: [], xGeneratedContent: null }
  ]);
  const [activeTab, setActiveTab] = useState(0);
  
  const originalLoadedMediaCountRef = useRef(0);

  const handleTabChange = (newTab) => {
    if (newTab === activeTab) return;
    setVariations((prev) => {
      const updated = [...prev];
      updated[activeTab] = {
        editorValue,
        images,
        videos,
        attachedFiles,
        uploadedImageIds,
        uploadLibraryId,
        xGeneratedContent,
      };
      if (updated[newTab]) {
        setEditorValue(updated[newTab].editorValue || "");
        setImages(updated[newTab].images || []);
        setVideos(updated[newTab].videos || []);
        setAttachedFiles(updated[newTab].attachedFiles || []);
        setUploadedImageIds(updated[newTab].uploadedImageIds || []);
        setUploadLibraryId(updated[newTab].uploadLibraryId || []);
        setXGeneratedContent(updated[newTab].xGeneratedContent || null);
      }
      return updated;
    });
    setActiveTab(newTab);
  };

  const handleAddVariation = () => {
    if (variations.length >= 3) return;
    setVariations((prev) => {
      const updated = [...prev];
      updated[activeTab] = {
        editorValue,
        images,
        videos,
        attachedFiles,
        uploadedImageIds,
        uploadLibraryId,
        xGeneratedContent,
      };
      const newIndex = updated.length;
      updated.push({
        editorValue: "",
        images: [],
        videos: [],
        attachedFiles: [],
        uploadedImageIds: [],
        uploadLibraryId: [],
        xGeneratedContent: null,
      });
      setActiveTab(newIndex);
      setEditorValue("");
      setImages([]);
      setVideos([]);
      setAttachedFiles([]);
      setUploadedImageIds([]);
      setUploadLibraryId([]);
      setXGeneratedContent(null);
      return updated;
    });
  };

  const handleDeleteVariation = (index) => {
    if (variations.length <= 1) return;
    setVariations((prev) => {
      // First ensure the active tab state is saved if it's not the one being deleted
      const updated = [...prev];
      if (activeTab !== index) {
        updated[activeTab] = {
          editorValue,
          images,
          videos,
          attachedFiles,
          uploadedImageIds,
          uploadLibraryId,
          xGeneratedContent,
        };
      }
      
      const newVariations = updated.filter((_, i) => i !== index);
      let newActiveTab = activeTab;
      if (index === activeTab) {
        newActiveTab = Math.max(0, index - 1);
        setEditorValue(newVariations[newActiveTab].editorValue || "");
        setImages(newVariations[newActiveTab].images || []);
        setVideos(newVariations[newActiveTab].videos || []);
        setAttachedFiles(newVariations[newActiveTab].attachedFiles || []);
        setUploadedImageIds(newVariations[newActiveTab].uploadedImageIds || []);
        setUploadLibraryId(newVariations[newActiveTab].uploadLibraryId || []);
        setXGeneratedContent(newVariations[newActiveTab].xGeneratedContent || null);
      } else if (index < activeTab) {
        newActiveTab = activeTab - 1;
      }
      setActiveTab(newActiveTab);
      return newVariations;
    });
  };
  useEffect(() => {
    const storedUser = localStorage.getItem("userProfile");
    if (storedUser) {
      setLoggedInUser(JSON.parse(storedUser));
    }
  }, []);

  // Pre-fill editor when editPost changes
  useEffect(() => {
    if (!editPost) return;

    const buildFromPost = (postData) => {
      // --- Parse content JSON ---
      const rawContent = postData.content || "";
      let parsedVariations = null;
      try {
        const str = String(rawContent).trim();
        if (str.startsWith("[") && str.endsWith("]")) {
          const arr = JSON.parse(str);
          if (Array.isArray(arr) && arr.length > 0 && arr[0].content !== undefined) {
            parsedVariations = arr;
          }
        }
      } catch (e) {}

      const allMedia = (postData.media || []).filter(m => m?.fileUrl);

      // Each image/video/document object carries its own media id + kind so add/remove stays consistent.
      const toImg = (m, desc) => ({ isExistingUrl: true, url: m.fileUrl, _kind: desc?.kind, _mid: desc?.mid || m.id });
      const toVid = (m, desc) => ({ preview: m.fileUrl, playing: false, isExisting: true, _kind: desc?.kind, _mid: desc?.mid || m.id });
      const toDoc = (m, desc) => ({ name: m.fileName || (m.fileUrl ? m.fileUrl.split("/").pop() : "Document Attachment"), id: m.id, url: m.fileUrl, isExisting: true, _kind: desc?.kind || "upload", _mid: desc?.mid || m.id });

      // Build ordered id descriptors for a variation. Creation order = uploads first, then library.
      const buildDescriptors = (v) => [
        ...((v.mediaIds || []).map(id => ({ kind: "upload", mid: id }))),
        ...((v.libraryMediaIds || []).map(id => ({ kind: "library", mid: id }))),
      ];

      const splitByType = (items, descriptors) => {
        const imgs = [];
        const vids = [];
        const docs = [];
        items.forEach((m, i) => {
          const desc = descriptors[i];
          const type = m?.mediaType?.toUpperCase();
          if (type === "VIDEO") vids.push(toVid(m, desc));
          else if (type === "DOCUMENT" || (m?.fileUrl && (m.fileUrl.toLowerCase().endsWith(".pdf") || m.fileUrl.toLowerCase().endsWith(".doc") || m.fileUrl.toLowerCase().endsWith(".docx")))) docs.push(toDoc(m, desc));
          else imgs.push(toImg(m, desc));
        });
        return { imgs, vids, docs };
      };

      const hasVariationId = allMedia.some(m => m?.variationId);

      const distributeMedia = (varList) => {
        if (hasVariationId) {
          return varList.map(v => {
            const items = allMedia.filter(m => m?.variationId === v.id);
            return splitByType(items, buildDescriptors(v));
          });
        }
        let offset = 0;
        return varList.map(v => {
          const descriptors = buildDescriptors(v);
          const count = descriptors.length;
          const slice = count > 0 ? allMedia.slice(offset, offset + count) : [];
          offset += count;
          return splitByType(slice, descriptors);
        });
      };

      if (parsedVariations && parsedVariations.length > 1) {
        const distributed = distributeMedia(parsedVariations);
        const newVariations = parsedVariations.map((v, i) => ({
          editorValue: v.content || "",
          images: distributed[i].imgs,
          videos: distributed[i].vids,
          attachedFiles: distributed[i].docs,
          uploadedImageIds: [],
          uploadLibraryId: [],
          xGeneratedContent: v.xGeneratedContent || null,
        }));
        setVariations(newVariations);
        setActiveTab(0);
        setEditorValue(newVariations[0].editorValue);
        setImages(newVariations[0].images);
        setVideos(newVariations[0].videos);
        setAttachedFiles(newVariations[0].attachedFiles);
        setUploadedImageIds([]);
        setUploadLibraryId([]);
      } else {
        const content = parsedVariations ? (parsedVariations[0]?.content || "") : rawContent;
        const dist = parsedVariations
          ? distributeMedia(parsedVariations)[0]
          : {
              imgs: allMedia.filter(m => m?.mediaType?.toUpperCase() === "IMAGE").map(m => toImg(m, null)),
              vids: allMedia.filter(m => m?.mediaType?.toUpperCase() === "VIDEO").map(m => toVid(m, null)),
              docs: allMedia.filter(m => m?.mediaType?.toUpperCase() === "DOCUMENT" || (m?.fileUrl && (m.fileUrl.toLowerCase().endsWith(".pdf") || m.fileUrl.toLowerCase().endsWith(".doc") || m.fileUrl.toLowerCase().endsWith(".docx")))).map(m => toDoc(m, null)),
            };
        setVariations([{ editorValue: content, images: dist.imgs, videos: dist.vids, attachedFiles: dist.docs, uploadedImageIds: [], uploadLibraryId: [], xGeneratedContent: null }]);
        setActiveTab(0);
        setEditorValue(content);
        setImages(dist.imgs);
        setVideos(dist.vids);
        setAttachedFiles(dist.docs);
        setUploadedImageIds([]);
        setUploadLibraryId([]);
        // Record how many media items exist on the server so we can detect user-initiated removals
        originalLoadedMediaCountRef.current = dist.imgs.length + dist.vids.length + dist.docs.length;
      }

      // --- Categories ---
      if (editPost.categories?.length > 0 && categoriesData) {
        const postCatIds = editPost.categories.map(c => c.categoryId || c.id).filter(Boolean);
        setCategories(categoriesData.filter(c => postCatIds.includes(c.id)));
        setCategoriesIds(postCatIds);
      }

      // --- Allow Edit ---
      setAllowEdit(!!editPost.allowEdit);
    };

    // Fetch fresh post data to get the full resolved media list (timeline feed may be partial)
    postDetailsByPostId(editPost.id)
      .then(res => {
        const freshPost = res?.post || res?.posts?.[0] || editPost;
        buildFromPost({ ...freshPost, categories: editPost.categories, allowEdit: editPost.allowEdit });
      })
      .catch(() => {
        buildFromPost(editPost);
      });

  }, [editPost?.id]);

  const addTrends = (newValue) => {
    if (!newValue) {
      setTrendsInput("");
      return;
    }
    const tags = String(newValue)
      .split(",")
      .map((t) => t.trim())
      .filter(Boolean);
    if (tags.length === 0) {
      setTrendsInput("");
      return;
    }
    setSelectedTrends((prev) => {
      const next = [...prev];
      for (const tag of tags) {
        if (!next.includes(tag)) next.push(tag);
      }
      return next;
    });
    setTrendsInput("");
  };
  // ðŸ"¹ Remove a selected trend
  const removeTrends = (trend) => {
    setSelectedTrends((prev) => prev.filter((t) => t !== trend));
  };

  const clear = () => {
    setPostText("");
    setCategories([]);
    setTaggedMembers([]);
    setCategoryInput("");
    setVideos([]);
    setImages([]);
    setIsTaggingVisible(false);
    setEditorValue("");
    setXGeneratedContent(null);
    setPostReviewData(null);
    setTaggedMemberIds([]);
    setCategoriesIds([]);
    setUploadedImageIds([]);
    setUploadLibraryId([]);
    setSelectedTrends([]);
    setSelectedTrendingTopic("");
    setCategoryError(false);
    setAllowEdit(false);
    setFeaturedUrl("");
    setAttachedFiles([]);
    setScheduleDate("");
    setScheduleTime("");
    setIsScheduleDialogOpen(false);
    
    setVariations([
      { editorValue: "", images: [], videos: [], attachedFiles: [], uploadedImageIds: [], uploadLibraryId: [], xGeneratedContent: null }
    ]);
    setActiveTab(0);
  };

  const [postId, setPostId] = useState(null);
  const [scheduleDate, setScheduleDate] = useState("");
  const [scheduleTime, setScheduleTime] = useState("");
  const [isScheduleDialogOpen, setIsScheduleDialogOpen] = useState(false);
  const dateInputRef = useRef(null);
  const timeInputRef = useRef(null);

  const formatDateForDisplay = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString + "T00:00:00");
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  useEffect(() => {
    if (isScheduleDialogOpen) {
      const now = new Date();
      // Only set if not already set, or you can force overwrite
      if (!scheduleDate) {
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, "0");
        const day = String(now.getDate()).padStart(2, "0");
        setScheduleDate(`${year}-${month}-${day}`);
      }
      if (!scheduleTime) {
        const hours = String(now.getHours()).padStart(2, "0");
        const mins = String(now.getMinutes()).padStart(2, "0");
        setScheduleTime(`${hours}:${mins}`);
      }
    } else {
      setScheduleDate("");
      setScheduleTime("");
    }
  }, [isScheduleDialogOpen]);

  const handlePost = async () => {
    if (categoriesIds.length === 0) {
      setCategoryError(true);
      toast.warning("Please select at least one category");
      return;
    }

    try {
      setLoading(true);
      setLoadingMessage("Publishing to feed...");

      if (!editorValue.trim()) {
        toast.error("Content is required.");
        setLoading(false);
        setLoadingMessage("");
        return;
      }
      let scheduledTimeUtc = null;
      if (scheduleDate && scheduleTime) {
        const combinedDateTime = new Date(`${scheduleDate}T${scheduleTime}`);
        scheduledTimeUtc = combinedDateTime.toISOString().split(".")[0] + "Z";
      }

      const currentVariations = [...variations];
      currentVariations[activeTab] = {
        editorValue, images, videos, attachedFiles, uploadedImageIds, uploadLibraryId, xGeneratedContent
      };
      
      const variationsPayload = currentVariations.map((v, i) => {
        const { mediaIds, libraryMediaIds, hasKnownMedia } = deriveVariationMedia(v);
        return {
          id: `var_${i}`,
          content: v.editorValue,
          xGeneratedContent: v.xGeneratedContent,
          mediaIds,
          libraryMediaIds,
          hasKnownMedia,
        };
      });

      const allMediaIds = Array.from(new Set(variationsPayload.flatMap(v => v.mediaIds || [])));
      const allLibraryMediaIds = Array.from(new Set(variationsPayload.flatMap(v => v.libraryMediaIds || [])));

      const postData = {
        content: variationsPayload.length === 1 ? variationsPayload[0].content : JSON.stringify(variationsPayload),
        variations: variationsPayload.length > 1 ? variationsPayload : null,
        xGeneratedContent: xGeneratedContent,
        categories: categoriesIds,
        mediaIds: allMediaIds,
        libraryMediaIds: allLibraryMediaIds,
        taggedUserIds: taggedMemberIds,
        allowEdit: allowEdit,
        featuredUrl: hasFeatured ? featuredUrl : null,
        scheduledTimeUtc: scheduledTimeUtc,
      };
      const result = await createPost(postData);
      if (result?.status === true) {
        toast.success("Post published to feed successfully");
        clear();
        if (onPostCreated) onPostCreated();
      } else {
        toast.error(result?.message || "Failed to create post. Please try again.");
        clear();
      }
    } catch (error) {
      console.error("Error in posting:", error.message);
      toast.error(error.message || "Something went wrong while creating the post.");
      clear();
    } finally {
      setLoading(false);
      setLoadingMessage("");
    }
  };

  const deriveVariationMedia = (v) => {
    const all = [...(v.images || []), ...(v.videos || []), ...(v.attachedFiles || [])];
    const mediaIds = [];
    const libraryMediaIds = [];
    let hasKnownMedia = false;
    all.forEach((m) => {
      const mid = m?._mid ?? m?.id;
      if (mid == null) return;
      hasKnownMedia = true;
      if (m._kind === "library") libraryMediaIds.push(mid);
      else mediaIds.push(mid);
    });
    return { mediaIds, libraryMediaIds, hasKnownMedia };
  };

  const handleSaveEdit = async () => {
    if (!editorValue.trim()) { toast.error("Content is required."); return; }
    try {
      setLoading(true);
      setLoadingMessage("Saving changes...");
      const currentVariations = [...variations];
      currentVariations[activeTab] = { editorValue, images, videos, attachedFiles, uploadedImageIds, uploadLibraryId, xGeneratedContent };
      const variationsPayload = currentVariations.map((v, i) => {
        const { mediaIds, libraryMediaIds, hasKnownMedia } = deriveVariationMedia(v);
        return {
          id: `var_${i}`,
          content: v.editorValue,
          xGeneratedContent: v.xGeneratedContent,
          mediaIds,
          libraryMediaIds,
          hasKnownMedia,
        };
      });
      const content = variationsPayload.length === 1 ? variationsPayload[0].content : JSON.stringify(variationsPayload);

      const currentMediaCount = variationsPayload.length === 1
        ? (variationsPayload[0].mediaIds.length + variationsPayload[0].libraryMediaIds.length +
          (currentVariations[0].images || []).filter(m => m?._mid == null && m?.isExistingUrl).length +
          (currentVariations[0].videos || []).filter(m => m?._mid == null && m?.isExisting).length)
        : null; // Only track for single-variation (multi-variation always sends media)
      const legacyItemRemoved = variationsPayload.length === 1 &&
        currentMediaCount !== null &&
        currentMediaCount < originalLoadedMediaCountRef.current;

      const anyMediaChanged = variationsPayload.some(v => v.hasKnownMedia) || legacyItemRemoved;
      const allMediaIds = anyMediaChanged
        ? Array.from(new Set(variationsPayload.flatMap(v => v.mediaIds || [])))
        : undefined;
      const allLibraryMediaIds = anyMediaChanged
        ? Array.from(new Set(variationsPayload.flatMap(v => v.libraryMediaIds || [])))
        : undefined;

      const variationsForPayload = variationsPayload.length > 1
        ? variationsPayload.map(({ id, content, xGeneratedContent, mediaIds, libraryMediaIds }) => ({ id, content, xGeneratedContent, mediaIds, libraryMediaIds }))
        : null;

      const result = await updatePostContent(editPostId, {
        content,
        ...(anyMediaChanged && { mediaIds: allMediaIds, libraryMediaIds: allLibraryMediaIds }),
        ...(variationsForPayload && { variations: variationsForPayload }),
      });
      if (result?.status) {
        toast.success("Post updated successfully");
        clear();
        if (onEditSuccess) onEditSuccess();
      } else {
        toast.error(result?.message || "Failed to update post.");
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong while updating the post.");
    } finally {
      setLoading(false);
      setLoadingMessage("");
    }
  };

  const [postReviewData, setPostReviewData] = useState(null);

  const prepareThePost = async (id) => {
    try {
      const response = await preparePost(id);
      if (response?.status === true) {
        setPostReviewData(response);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const addCategory = (category) => {
    if (!categories?.some((cat) => cat.id === category.id)) {
      setCategories((prev) => [...prev, category]);
      setCategoriesIds((prev) => [...prev, category.id]);
      setCategoryInput("");
      setCategoryError(false);
    }
  };

  const removeCategory = (category) => {
    setCategories((prev) => prev.filter((cat) => cat.id !== category.id));
    setCategoriesIds((prev) => prev.filter((id) => id !== category.id));
  };

  const handleAddNewCategory = async (name) => {
    if (!name?.trim()) {
      setAddCategoryDialogOpen(true);
      return;
    }
    setCategoryCreating(true);
    try {
      const response = await UserService.addNewCategories({ name: name.trim() });
      if (response?.status === true) {
        const refreshed = await UserService.getAllCategories();
        if (refreshed?.status === true) {
          setCategoriesData(refreshed.categories);
          const created = refreshed.categories.find(
            (c) => c.name.toLowerCase() === name.trim().toLowerCase()
          );
          if (created) addCategory(created);
        }
        toast.success(`Category "${name}" created and added`);
      } else {
        toast.error(response?.message || "Failed to create category");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to create category");
    } finally {
      setCategoryCreating(false);
      setAddCategoryDialogOpen(false);
      setNewCategoryDialogInput("");
    }
  };

  const addMember = (member) => {
    if (member && !taggedMembers.some((m) => m.id === member.id)) {
      setTaggedMembers((prev) => [...prev, member]);
      setTaggedMemberIds((prev) => [...prev, member.id]);
      setTaggedMemberInput("");
    }
  };

  const removeTaggedMember = (member) => {
    setTaggedMembers((prev) => prev.filter((m) => m.id !== member.id));
    setTaggedMemberIds((prev) => prev.filter((id) => id !== member.id));
  };

  const handleImageUpload = async (e) => {
    // console.log(e.target.files);
    const files = Array.from(e.target.files);
    files.forEach((f) => { f._kind = "upload"; });
    setImages((prevImages) => [...prevImages, ...files]);
    try {
      setLoading(true);
      setLoadingMessage("Uploading...");
      const formData = new FormData();
      files.forEach((file) => {
        formData.append("files", file);
      });
      formData.append("mediaType", "image");
      const response = await uploadMedia(formData);
      if (response?.status === true) {
        const ids = response?.mediaUploadData?.imageIds || [];
        // Attach each returned id to its uploaded file so save can resend it
        files.forEach((f, i) => { f._mid = ids[i]; });
        setUploadedImageIds((prev) => [...prev, ...ids]);
        toast.success("Successfully Added");
      }
    } catch (error) {
      console.log(error, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveImage = (image, index) => {
    setImages((prevImages) => prevImages.filter((_, i) => i !== index));
    // Keep the parallel id arrays in sync so the removed image isn't resaved
    if (image?._mid != null) {
      if (image._kind === "library") {
        setUploadLibraryId((prev) => {
          const idx = prev.findIndex((id) => String(id) === String(image._mid));
          return idx === -1 ? prev : prev.filter((_, i) => i !== idx);
        });
      } else if (image._kind === "upload") {
        setUploadedImageIds((prev) => {
          const idx = prev.findIndex((id) => String(id) === String(image._mid));
          return idx === -1 ? prev : prev.filter((_, i) => i !== idx);
        });
      }
    }
  };

  const handleImageUploader = async (images) => {
    try {
      setOpen(false);
      setLoading(true);
      setLoadingMessage("Uploading...");
      if (images[0] instanceof File) {
        images.forEach((f) => { f._kind = "upload"; });
        setImages((prev) => [...prev, ...images]);
        const formData = new FormData();
        images.forEach((file) => {
          formData.append("files", file);
        });
        formData.append("mediaType", "image");

        const response = await uploadMedia(formData);
        if (response?.status === true) {
          const ids = response?.mediaUploadData?.imageIds || [];
          images.forEach((f, i) => { f._mid = ids[i]; });
          setUploadedImageIds((prev) => [...prev, ...ids]);
          toast.success("Successfully Added");
        }
      } else {
        // Library images — tag each with its library id
        const withMeta = images.map((img) => ({ ...img, _kind: "library", _mid: img.id }));
        setImages((prev) => [...prev, ...withMeta]);
        const ids = images.map((img) => img.id);
        setUploadLibraryId((prev) => [...prev, ...ids]);
        toast.success("Successfully Added from existing list");
      }
    } catch (error) {
      console.log(error, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleVideoUpload = async (event) => {
    const uploadedFiles = Array.from(event.target.files);
    if (!uploadedFiles?.length) return;
    try {
      setLoading(true);
      setLoadingMessage("Uploading...");
      const formData = new FormData();
      uploadedFiles.forEach((file) => {
        formData.append("files", file);
      });
      formData.append("mediaType", "video");
      const response = await uploadMedia(formData);
      if (response?.status === true) {
        const ids = response?.mediaUploadData?.videoIds || [];
        const videoPreviews = uploadedFiles.map((file, i) => ({
          file,
          preview: URL.createObjectURL(file),
          playing: false,
          _kind: "upload",
          _mid: ids[i],
          id: ids[i],
        }));
        setVideos((prev) => [...prev, ...videoPreviews]);
        setUploadedImageIds((prev) => [...prev, ...ids]);
        toast.success("Successfully Added");
      }
    } catch (error) {
      console.log(error, "error");
    } finally {
      setLoading(false);
      event.target.value = "";
    }
  };

  const handleVideoConfirm = async (selectedVideos) => {
    try {
      setLoading(true);
      setLoadingMessage("Uploading...");
      const existingVideos = selectedVideos?.filter((vid) => !vid.isNew);
      const newVideos = selectedVideos?.filter((vid) => vid.isNew);
      let uploadedPreviews = [];
      let uploadedIds = [];
      if (newVideos.length > 0) {
        const formData = new FormData();
        for (const vid of newVideos) {
          formData.append("files", vid.file);
        }
        formData.append("mediaType", "video");
        const response = await uploadMedia(formData);
        if (response?.status === true) {
          uploadedIds = response?.mediaUploadData?.videoIds || [];
          uploadedPreviews = newVideos.map((vid, idx) => ({
            id: uploadedIds[idx],
            preview: vid.preview,
            playing: false,
            _kind: "upload",
            _mid: uploadedIds[idx],
          }));
        }
      }

      // final combined
      const unified = [
        ...existingVideos.map((vid) => ({
          id: vid.id,
          preview: vid.preview,
          playing: false,
          _kind: "library",
          _mid: vid.id,
        })),
        ...uploadedPreviews,
      ];
      const existingIds = existingVideos.map((vid) => vid.id);
      setUploadLibraryId((prev) => [...prev, ...existingIds]);
      setUploadedImageIds((prev) => [...prev, ...uploadedIds]);
      // setUploadedImageIds((prev) => [...prev, ...existingIds, ...uploadedIds]);
      setVideos((prev) => [...prev, ...unified]);
      toast.success("Successfully Added");
    } catch (error) {
      console.error("Video upload error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveVideo = (index) => {
    setVideos((prev) => {
      const removed = prev[index];
      if (removed?._mid != null) {
        if (removed._kind === "library") {
          setUploadLibraryId((ids) => {
            const idx = ids.findIndex((id) => String(id) === String(removed._mid));
            return idx === -1 ? ids : ids.filter((_, i) => i !== idx);
          });
        } else if (removed._kind === "upload") {
          setUploadedImageIds((ids) => {
            const idx = ids.findIndex((id) => String(id) === String(removed._mid));
            return idx === -1 ? ids : ids.filter((_, i) => i !== idx);
          });
        }
      }
      return prev.filter((_, i) => i !== index);
    });
  };

  const handleAttachmentUpload = async (event) => {
    const files = Array.from(event.target.files);
    if (!files.length) return;
    try {
      setLoading(true);
      setLoadingMessage("Uploading attachment...");
      const formData = new FormData();
      files.forEach((file) => formData.append("files", file));
      formData.append("mediaType", "document");
      const response = await uploadMedia(formData);
      if (response?.status === true) {
        const ids = response?.mediaUploadData?.documentIds || response?.mediaUploadData?.imageIds || [];
        setUploadedImageIds((prev) => [...prev, ...ids]);
        setAttachedFiles((prev) => [
          ...prev,
          ...files.map((f, i) => ({ name: f.name, id: ids[i], _kind: "upload", _mid: ids[i] })),
        ]);
        toast.success("Attachment added");
      }
    } catch (error) {
      toast.error("Failed to upload attachment");
    } finally {
      setLoading(false);
      setLoadingMessage("");
      event.target.value = "";
    }
  };

  const handleRemoveAttachment = (index) => {
    setAttachedFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handlePauseVideo = (index) => {
    setVideos((prev) =>
      prev.map((video, i) =>
        i === index ? { ...video, playing: false } : video
      )
    );
  };

  const handlePlayVideo = (index) => {
    setVideos((prev) =>
      prev.map((video, i) =>
        i === index ? { ...video, playing: true } : { ...video, playing: false }
      )
    );

    setTimeout(() => {
      const videoEl = document.querySelectorAll("video")[index];
      if (videoEl) videoEl.play();
    }, 0);
  };
  const platforms = ["All", "Linkedin", "Twitter/X", "Instagram", "Facebook"];
  const [selected, setSelected] = useState(["All"]);
  const selectedPublishingPlatforms = selected.filter((platform) => platform !== "All");
  const activePlatformsForLimit =
    selectedPublishingPlatforms.length > 0 ? selectedPublishingPlatforms : ["Linkedin"];

  const getStrictestComposition = (value) =>
    activePlatformsForLimit
      .map((platform) => composePlatformContent(value, platform, businessPages))
      .reduce((smallest, current) =>
        current.maxBaseCharacters < smallest.maxBaseCharacters ? current : smallest
      );

  const handleEditorValueChange = (nextValue) => {
    const clampedValue = activePlatformsForLimit.reduce(
      (currentValue, platform) =>
        clampPlatformContent(currentValue, platform, businessPages),
      nextValue
    );
    setEditorValue(clampedValue);
  };

  const handleChange = (platform) => {
    if (platform === "All") {
      setSelected(["All"]);
    } else {
      // console.log(platform, "plat");
      const newSelection = selected.includes(platform)
        ? selected.filter((p) => p !== platform)
        : [...selected.filter((p) => p !== "All"), platform];
      setSelected(newSelection);
    }
  };

  const handleConfirm = () => {
    clear();
    setDiscard(false);
  };

  const handleDiscard = () => {
    clear();
    setDiscard(true);
  };

  const handleClose = () => {
    setPostReview(false);
    setActivities(false);
  };

  const handleActivities = () => {
    setActivities(true);
  };

  const fetchAllUsers = async () => {
    const org_id = sessionStorage.getItem("orgId");
    try {
      const response = await employeeUserListing(org_id);
      if (response?.status === true) {
        setUsersData(response?.users || []);
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  const fetchAllTrendingTopics = async () => {
    try {
      const [employeeRes, globalRes] = await Promise.all([
        employeeTrendingTopics().catch(() => null),
        globalTrendingTopics().catch(() => null)
      ]);
      
      const employeeTopics = employeeRes?.status ? (employeeRes.trendingTopics || employeeRes.topics || []) : [];
      const orgTopics = globalRes?.status ? (globalRes.trendingTopics || globalRes.topics || []) : [];
      
      const cleanTopics = (topics) => [...new Set(topics)]
        .map(t => typeof t === 'string' ? t.replace(/^\[|\]$/g, '').replace(/^"|"$/g, '').trim() : t)
        .filter(t => t && t !== "]" && t !== "[");

      const parsedOrgTopics = cleanTopics(orgTopics);
      const parsedPersonalTopics = cleanTopics(employeeTopics);
      
      setOrgTrendsData(parsedOrgTopics);
      setPersonalTrendsData(parsedPersonalTopics);
      // trendsData is managed by the useEffect listening to trendingTopicType
    } catch (error) {
      console.log(error, "error");
    }
  };

  const [aiLoader, setAiLoader] = useState(false);
  const [showGeneratingPopup, setShowGeneratingPopup] = useState(false);
  const [dots, setDots] = useState(".");
  const [editorValue, setEditorValue] = useState("");
  const [xGeneratedContent, setXGeneratedContent] = useState(null);
  const [apiValue, setApiValue] = useState("");
  const handleTopicInputChange = (value) => {
    setPostText(value);
    if (selectedTrendingTopic && value !== selectedTrendingTopic) {
      setSelectedTrendingTopic("");
    }
  };

  useEffect(() => {
    let interval;
    if (aiLoader) {
      interval = setInterval(() => {
        setDots((prev) => (prev.length >= 2 ? "." : prev + "."));
      }, 1000);
    } else {
      setDots(".");
    }
    return () => clearInterval(interval);
  }, [aiLoader]);
  const aiContentGenerator = async () => {
    try {
      if (!postText) {
        toast.error("Please enter a topic to generate content");
        return;
      }
      setAiLoader(true);
      setShowGeneratingPopup(true);
      const xComposition = composePlatformContent("", "x", businessPages);
      const payload = {
        topic: postText,
        xMaxCharacters: xComposition.maxBaseCharacters || 200,
      };
      const response = await Content_Generation(payload);
      if (response?.contentGenerateResponseDTO?.generatedText) {
        let text = response.contentGenerateResponseDTO.generatedText;
        if (isPayoneerDomain(businessPages)) {
          text = stripHashtagsFromText(text);
        }
        handleEditorValueChange(text);
        setXGeneratedContent(response?.contentGenerateResponseDTO?.xgeneratedContent || null);
      }
    } catch (error) {
      console.log(error, "error");
    } finally {
      setAiLoader(false);
      setShowGeneratingPopup(false);
    }
  };

  const handleClickTopics = (data) => {
    if (!data) {
      toast.error("Please select a topic");
      return;
    }
    setSelectedTrendingTopic(data);
    setPostText(data);
  };

  useEffect(() => {
    fetchAllTrendingTopics();
  }, []);

  // useEffect(() => {
  //   if (apiValue) {
  //     const htmlWithPoints = convertToNumberedList(apiValue);
  //     setEditorValue(htmlWithPoints);
  //   }
  // }, [apiValue]);

  // const convertToNumberedList = (text) => {
  //   const lines = text
  //     .split(/\n+/) // split on one or more newlines
  //     .map((line) => line.trim())
  //     .filter((line) => line.length > 0);

  //   if (lines.length === 0) return "";

  //   return `<ol>${lines.map((l) => `<li>${l}</li>`).join("")}</ol>`;
  // };

  const isFormDirty =
    postText.trim() !== "" ||
    categories.length > 0 ||
    taggedMembers.length > 0 ||
    videos.length > 0 ||
    images.length > 0 ||
    editorValue.trim() !== "" ||
    selectedTrends.length > 0 ||
    featuredUrl.trim() !== "" ||
    attachedFiles.length > 0 ||
    allowEdit;

  return (
    <>
      <LoaderOverlay loading={loading} message={loadingMessage} />
      <Card
        id="onboarding-create-post-area"
        className="postCreation-container"
        elevation={0}
        sx={{ padding: { xs: 1.5, sm: 2 }, width: "100%", boxSizing: "border-box" }}
      >
        <Box
          display="flex"
          flexDirection={{ xs: "column", sm: "column", md: "row" }}
          // padding="8px 5px 0px 11px"
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", md: "center" }}
          width="100%"
          gap={{ xs: 2, sm: 2, md: 0 }}
        >
          {/* Left Section */}
          <Box
            display="flex"
            width={{ xs: "100%", md: "50%" }}
            alignItems="center"
            // mb={{ xs: 1, md: 2 }}
          >
            {userProfile?.profilePicture ? (
              <Avatar
                sx={{ mr: 2 }}
                src={userProfile?.profilePicture}
                alt={userProfile?.name}
              />
            ) : (
              <Avatar sx={{ mr: 2 }}>{userProfile?.name?.[0]}</Avatar>
            )}
            <Box>
              <Typography
                variant="body1"
                fontWeight={500}
                color="#3B3B3B"
                // fontSize={{ xs: 16, sm: 18, md: 19 }}
              >
                {userProfile?.name || ""}
              </Typography>
              <Typography
                variant="body1"
                color="#95919D"
                fontSize={{ xs: 13, sm: 14, md: 14 }}
              >
                {userProfile?.jobTitle || ""}
              </Typography>
            </Box>
          </Box>

          {/* Right Section */}
          <Box
            display="flex"
            width={{ xs: "100%", md: "50%" }}
            flexDirection={{ xs: "column", sm: "column", md: "row" }}
            borderTop={{ xs: "1px solid #E0E0E0", md: "none" }}
          >
            {/* Points */}
            <Box
              width={{ xs: "100%", md: "54%" }}
              display="flex"
              gap={2}
              justifyContent="center"
              alignItems="center"
              borderRight={{ md: "1px solid #BEBEBE" }}
              borderBottom={{ xs: "1px solid #E0E0E0", md: "none" }}
              py={{ xs: 1, md: 0 }}
            >
              <Typography
                variant="body1"
                fontSize={{ xs: 13, sm: 14, md: 14 }}
                color="#95919D"
              >
                My Total Point:
              </Typography>
              <img src={coins} alt="coin" width={18} height={18} />
              <Typography
                color="#252525"
                fontWeight={600}
                fontSize={{ xs: 18, md: 17 }}
                variant="h6"
              >
                {loyaltyPoints?.loyaltyPoints || 0}
              </Typography>
            </Box>

            {/* Activity */}
            <Box
              alignItems="center"
              justifyContent={{ xs: "center", md: "end" }}
              gap={2}
              display="flex"
              width={{ xs: "100%", md: "46%" }}
              onClick={handleActivities}
              sx={{ cursor: "pointer" }}
              py={{ xs: 1, md: 0 }}
            >
              <Typography
                variant="body1"
                fontSize={{ xs: 13, sm: 14, md: 14 }}
                color="#95919D"
              >
                My Activity:
              </Typography>
              <img src={message} alt="post" width={18} height={18} />
              <Typography
                color="#252525"
                fontWeight={600}
                fontSize={{ xs: 18, md: 17 }}
                variant="h6"
              >
                {/* 4633 */}
              </Typography>
            </Box>
          </Box>
        </Box>

        <Grid
          container
          sx={{
            minHeight: "100%",
            height: "100%",
            display: "flex",
            width: "100% !important",
            margin: "0px !important",
            alignItems: "stretch",
          }}
          spacing={2}
          alignItems="stretch"
        >
          <Grid
            pl={0}
            sx={{
              display: "flex",
              flexDirection: "column",
              paddingLeft: "0px !important",
            }}
            // mt={0.5}
            item
            xs={12}
            md={6}
            sm={12}
          >
            <Box
              id="onboarding-compose-input"
              sx={{
                display: "flex",
                backgroundColor: "#F8F9FC",
                border: "1px solid #e0e0e0",
                borderRadius: "12px",
                padding: "12px",
                flexDirection: "row",
                flexWrap: "wrap",
                alignItems: "flex-start",
              }}
            >
              <TextField
                variant="standard"
                placeholder="Compose"
                InputProps={{
                  disableUnderline: true,
                  sx: {
                    fontSize: "14px",
                    flex: 1,
                    color: "#7c7676",
                    backgroundColor: "transparent",
                  },
                }}
                multiline
                fullWidth
                value={postText}
                onChange={(e) => handleTopicInputChange(e.target.value)}
                sx={{
                  flex: 1,
                  minWidth: "200px",
                  ".MuiInputBase-root": {
                    backgroundColor: "transparent",
                  },
                }}
              />
              {aiLoader ? (
                <Button
                  variant="contained"
                  disabled
                  sx={{
                    width: "132px",
                    background: "linear-gradient(to right, #BC77F4, #0047AB)",
                    color: "#fff !important",
                    borderRadius: "8px",
                    textTransform: "none",
                    fontSize: "13px",
                    padding: "5px 10px",
                    boxShadow: "none",
                    fontWeight: 500,
                    alignSelf: "flex-end",
                    cursor: "not-allowed !important",
                    pointerEvents: "auto !important",

                    "&:hover": {
                      background: "linear-gradient(to right, #8a6be9, #306ddf)",
                      boxShadow: "none",
                    },
                    "&.Mui-disabled": {
                      opacity: 0.65,
                      color: "#fff !important",
                      background: "linear-gradient(to right, #BC77F4, #0047AB)",
                      cursor: "not-allowed !important",
                      pointerEvents: "auto !important",
                    },
                  }}
                >
                  ✨ Generating{dots}
                </Button>
              ) : (
                <Button
                  variant="contained"
                  sx={{
                    width: "132px",
                    background: "linear-gradient(to right, #BC77F4, #0047AB)",
                    color: "#fff",
                    borderRadius: "8px",
                    fontSize: "13px",
                    textTransform: "none",
                    padding: "5px 10px",
                    boxShadow: "none",
                    fontWeight: 500,
                    alignSelf: "flex-end",

                    "&:hover": {
                      background: "linear-gradient(to right, #8a6be9, #306ddf)",
                      boxShadow: "none",
                    },
                  }}
                  onClick={aiContentGenerator}
                >
                  ✨ Generate
                </Button>
              )}
            </Box>

            <Box mb={2}>
              <Box>
              <Autocomplete
                multiple
                options={categoriesData.filter(
                  (cat) => !categories.some((c) => c.id === cat.id)
                )}
                value={categories}
                inputValue={categoryInput}
                onInputChange={(event, newInputValue, reason) => {
                  if (reason !== "reset") setCategoryInput(newInputValue);
                }}
                onChange={(event, newValues, reason, details) => {
                  const selected = details?.option;
                  if (selected?.__isFeatured) {
                    const existing = categoriesData.find(
                      (c) => c.name?.toLowerCase() === "featured"
                    );
                    if (existing) {
                      addCategory(existing);
                    } else {
                      handleAddNewCategory("Featured");
                    }
                    return;
                  }
                  if (selected?.__isAddNew) {
                    handleAddNewCategory(selected.name);
                    return;
                  }
                  const valid = newValues.filter((v) => !v?.__isAddNew && !v?.__isFeatured);
                  setCategories(valid);
                  setCategoriesIds(valid.map((c) => c.id));
                  setCategoryError(false);
                  setCategoryInput("");
                }}
                filterOptions={(options, params) => {
                  const alreadyFeatured = categories.some(
                    (c) => c.name?.toLowerCase() === "featured"
                  );
                  const nonFeaturedOptions = options.filter(
                    (opt) => opt.name?.toLowerCase() !== "featured"
                  );
                  const filtered = nonFeaturedOptions.filter((opt) =>
                    opt.name?.toLowerCase().includes(params.inputValue.toLowerCase())
                  );
                  const label = params.inputValue.trim();
                  const alreadyExists = nonFeaturedOptions.some(
                    (opt) => opt.name?.toLowerCase() === label.toLowerCase()
                  );
                  if (!alreadyExists) {
                    filtered.push({ __isAddNew: true, name: label });
                  }
                  if (!alreadyFeatured) {
                    filtered.unshift({ __isFeatured: true, name: "Featured" });
                  }
                  return filtered;
                }}
                getOptionLabel={(option) =>
                  typeof option === "string" ? option : option?.name || ""
                }
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderTags={(tagValue, getTagProps) =>
                  tagValue.map((option, index) => (
                    <Chip
                      {...getTagProps({ index })}
                      key={option.id || index}
                      label={option.name}
                      className="taggedMembers-cards"
                      deleteIcon={<CloseIcon style={{ fontSize: 14 }} />}
                    />
                  ))
                }
                renderOption={(props, option) => (
                  <li
                    {...props}
                    key={option.__isFeatured ? "featured-pin" : option.__isAddNew ? "add-new" : option.id}
                  >
                    {option.__isFeatured ? (
                      <Box display="flex" alignItems="center" gap={1}>
                        <StarIcon fontSize="small" sx={{ color: "inherit" }} />
                        <Typography fontSize="13px" sx={{ color: "inherit", fontWeight: 600 }}>
                          Featured
                        </Typography>
                      </Box>
                    ) : option.__isAddNew ? (
                      <Box display="flex" alignItems="center" gap={1}>
                        <AddIcon fontSize="small" sx={{ color: "inherit" }} />
                        <Typography fontSize="13px" sx={{ color: "inherit", fontWeight: 500 }}>
                          {option.name ? `Add "${option.name}"` : "Add New Category"}
                        </Typography>
                      </Box>
                    ) : (
                      <Typography fontSize="13px" sx={{ color: "inherit" }}>{option.name}</Typography>
                    )}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder={categories.length === 0 ? "Select or add categories *" : ""}
                    error={categoryError}
                    helperText={categoryError ? "Please select at least one category" : ""}
                    size="small"
                    sx={{
                      mt: 1,
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "8px",
                        fontSize: "13px",
                        flexWrap: "wrap",
                      },
                    }}
                  />
                )}
                PopperComponent={(props) => (
                  <Popper
                    {...props}
                    sx={{
                      padding: "8px",
                      "& .MuiAutocomplete-listbox": {
                        padding: "5px",
                        border: "1px solid #DEDFE5",
                        borderRadius: "8px",
                        "& li": {
                          backgroundColor: "#FFFFFF",
                          padding: "8px",
                          borderRadius: "8px",
                          cursor: "pointer",
                          color: "#3B3B3B",
                          transition: "background-color 0.2s ease, color 0.2s ease",
                        },
                        "& li:hover": {
                          backgroundColor: "#0047AB",
                          color: "#FFFFFF",
                        },
                        "& li:first-child": {
                          color: "#B8860B",
                          borderBottom: "1px solid #f0f0f0",
                          marginBottom: "4px",
                        },
                        "& li:first-child:hover": {
                          backgroundColor: "#FFF8E1",
                          color: "#B8860B",
                        },
                        "& li:last-child": {
                          color: "#0047AB",
                          borderTop: "1px solid #f0f0f0",
                          marginTop: "4px",
                        },
                        "& li:last-child:hover": {
                          backgroundColor: "#0047AB",
                          color: "#FFFFFF",
                        },
                      },
                    }}
                  />
                )}
                loading={categoryCreating}
                disableClearable
              />
              </Box>
            </Box>
            {hasFeatured && (
              <Box mb={2}>
                <TextField
                  fullWidth
                  size="small"
                  value={featuredUrl}
                  onChange={(e) => setFeaturedUrl(e.target.value)}
                  placeholder="Paste featured article or website URL"
                  variant="outlined"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LinkIcon fontSize="small" sx={{ color: "#B8860B" }} />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      fontSize: "13px",
                      "& fieldset": { borderColor: "#FFD700" },
                      "&:hover fieldset": { borderColor: "#B8860B" },
                      "&.Mui-focused fieldset": { borderColor: "#B8860B" },
                    },
                  }}
                />
              </Box>
            )}
            <Box
              sx={{
                backgroundColor: "#f8f6fe", // Matches light purple background
                padding: "16px 24px",
                pt: 0,
                //   borderRadius: "8px",
                overflowX: "auto",
                whiteSpace: "nowrap",
              }}
            >
              <Box
                display="flex"
                flexDirection="column"
                mt={1}
                gap={1}
                width={{ xs: "100%", md: "100%" }}
              >
                {/* <Autocomplete
                  freeSolo
                  options={trendsData.filter(
                    (trend) =>
                      trend.toLowerCase().includes(trendsInput.toLowerCase()) &&
                      !selectedTrends.includes(trend)
                  )}
                  inputValue={trendsInput}
                  onInputChange={(event, newInputValue) =>
                    setTrendsInput(newInputValue)
                  }
                  onChange={(event, newValue) => addTrends(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      sx={{
                        color: "#E0E0E0",
                        "& .MuiInputBase-input": {
                          fontSize: "12px",
                        },
                      }}
                      placeholder="Trending Topics"
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          addTrends(trendsInput);
                        }
                      }}
                    />
                  )}
                  PopperComponent={(props) => (
                    <Popper
                      {...props}
                      sx={{
                        width: "200px",
                        padding: "8px",
                        "& .MuiAutocomplete-listbox": {
                          padding: "5px",
                          border: "1px solid #DEDFE5",
                          borderRadius: "8px",
                          "& li": {
                            backgroundColor: "#FFFFFF",
                            padding: "8px",
                            borderRadius: "8px",
                            cursor: "pointer",
                            transition: "background-color 0.3s ease",
                          },
                          "& li:hover": {
                            backgroundColor: "#0047AB",
                            color: "#FFFFFF",
                          },
                        },
                      }}
                    />
                  )}
                  getOptionLabel={(option) =>
                    typeof option === "string" ? option : option || ""
                  }
                  disableClearable
                /> */}
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 0.5 }}>
                  <Typography
                    variant="body2"
                    sx={{ color: "#95919D", fontWeight: 400 }}
                  >
                    Trending Topics
                  </Typography>
                  {/* <Select
                    size="small"
                    value={trendingTopicType}
                    onChange={(e) => setTrendingTopicType(e.target.value)}
                    sx={{
                      height: 24,
                      fontSize: "12px",
                      "& .MuiSelect-select": { py: 0, px: 1 },
                    }}
                  >
                    <MenuItem value="org" sx={{ fontSize: "12px" }}>Organization</MenuItem>
                    <MenuItem value="personal" sx={{ fontSize: "12px" }}>Personal</MenuItem>
                  </Select> */}
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                    overflowX: "auto",
                    pb: 1,
                    "&::-webkit-scrollbar": { height: "6px" },
                    "&::-webkit-scrollbar-thumb": { backgroundColor: "#d1d5db", borderRadius: "10px" },
                    "&::-webkit-scrollbar-track": { backgroundColor: "#f3f4f6", borderRadius: "10px" }
                  }}
                >
                  {trendsData?.map((topic, index) => (
                    <Chip
                      onClick={() => handleClickTopics(topic)}
                      key={index}
                      label={topic}
                      variant="outlined"
                      sx={{
                        backgroundColor:
                          selectedTrendingTopic === topic ? "#d9e7ff" : "#eef2fb",
                        borderColor:
                          selectedTrendingTopic === topic ? "#0047AB" : "#73a3f3",
                        borderRadius: "24px",
                        fontSize: "11px",
                        fontWeight: selectedTrendingTopic === topic ? 500 : "400",
                        padding: "3px 8px",
                        color: selectedTrendingTopic === topic ? "#0047AB" : "#222",
                        height: "auto",
                        whiteSpace: "nowrap",
                      }}
                    />
                  ))}
                </Box>
                  {/* {selectedTrends?.map((trend, index) => (
                    <Chip
                      key={index}
                      label={trend}
                      onDelete={() => removeTrends(trend)}
                      deleteIcon={<CloseIcon fontSize="10px" />}
                      sx={{
                        backgroundColor: "#E7F1FF",
                        border: "1px solid #2D76DC",
                        color: "#2D76DC",
                        fontWeight: 400,
                        fontSize: "10px",
                        height: "24px",
                      }}
                    />
                  ))} */}
                </Box>
            </Box>

            {images?.length > 0 && (
              <Box mt={2} className="img_container">
                <Typography color="#9C9C9C">
                  {`Upload from Library : ${images?.length}`}
                </Typography>
                <Box mt={1} width={"100%"} sx={{ display: "flex", gap: 1, flexWrap: "wrap", alignItems: "center" }}>
                  <IconButton component="label" className="AddIcon">
                    <AddIcon />
                    <input
                      type="file"
                      accept="image/*"
                      multiple
                      onChange={handleImageUpload}
                      hidden
                    />
                  </IconButton>

                  {images?.map((image, index) => {
                    const imgSrc =
                      image instanceof File
                        ? URL.createObjectURL(image)
                        : typeof image === "string"
                        ? image
                        : image?.url || image?.fileUrl || image?.path || "";
                    return (
                      <Box key={index} sx={{ position: "relative", display: "inline-block" }}>
                        <img
                          src={imgSrc}
                          alt={`uploaded-${index}`}
                          className="containerImage"
                          style={{ width: 80, height: 80, objectFit: "cover", borderRadius: 8, display: "block" }}
                        />
                        <IconButton
                          size="small"
                          onClick={() => handleRemoveImage(image, index)}
                          sx={{
                            position: "absolute", top: -6, right: -6,
                            bgcolor: "rgba(0,0,0,0.55)", color: "#fff", padding: "2px",
                            width: 18, height: 18, zIndex: 2,
                            "&:hover": { bgcolor: "rgba(0,0,0,0.8)" },
                          }}
                        >
                          <CloseIcon sx={{ fontSize: 11 }} />
                        </IconButton>
                      </Box>
                    );
                  })}
                </Box>
              </Box>
            )}

            {videos.length > 0 && (
              <Box
                display="flex"
                gap={2}
                sx={{ maxHeight: 400, overflowY: "auto" }}
                flexWrap="wrap"
                mt={2}
                mb={2}
              >
                {videos.map((video, index) => (
                  <Box key={index} className="videoContainer">
                    <video
                      src={video.preview}
                      className="videos"
                      controls={videos[index].playing}
                      // onClick={(e) => e.target.pause()}
                      // onPause={() => handlePlayVideo(index)}
                      onPlay={() => handlePlayVideo(index)}
                      onPause={() => handlePauseVideo(index)}
                    />
                    {!video.playing && (
                      <Box
                        className="playButton"
                        onClick={() => handlePlayVideo(index)}
                      >
                        <Box className="playIcon">
                          <PlayArrowIcon
                            style={{ fontSize: 35, color: "#0047AB" }}
                          />
                        </Box>
                      </Box>
                    )}
                    <IconButton
                      size="small"
                      style={{
                        position: "absolute",
                        top: 5,
                        background: "#FFFFFF",
                        right: 5,
                        color: "#fff",
                      }}
                      onClick={() => handleRemoveVideo(index)}
                    >
                      <CloseIcon
                        className="closeIcon"
                        sx={{ color: "#0047AB" }}
                      />
                    </IconButton>
                  </Box>
                ))}
              </Box>
            )}

            {attachedFiles.length > 0 && (
              <Box mt={2} sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                {attachedFiles.map((file, index) => (
                  <Chip
                    key={index}
                    icon={<AttachFileIcon sx={{ fontSize: 16, color: "#1D4ED8 !important" }} />}
                    label={file.name || file.fileName || "Document Attachment"}
                    onDelete={() => handleRemoveAttachment(index)}
                    deleteIcon={<CloseIcon style={{ fontSize: 14 }} />}
                    sx={{
                      backgroundColor: "#EFF6FF",
                      color: "#1D4ED8",
                      border: "1px solid #BFDBFE",
                      fontSize: "12px",
                      fontWeight: 500,
                      height: "32px",
                      px: 0.5,
                      "& .MuiChip-deleteIcon": { color: "#1D4ED8", "&:hover": { color: "#1E40AF" } },
                    }}
                  />
                ))}
              </Box>
            )}

            {isTaggingVisible && (
              <Box className="tagging-container" p={1}>
                <Typography className="count">{`Members Tagged : ${taggedMembers?.length}`}</Typography>

                <Autocomplete
                  freeSolo={false} // âœ… keep only userData objects, not free text
                  options={userData || []}
                  getOptionLabel={(option) => option?.name || ""} // âœ… show name
                  value={null} // avoid controlled warning, we only use input value
                  inputValue={taggedMemberInput}
                  onInputChange={(event, newInputValue) =>
                    setTaggedMemberInput(newInputValue)
                  }
                  onChange={(event, newValue) => {
                    if (newValue) addMember(newValue);
                  }}
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      {...props}
                      key={option.id}
                      sx={{ display: "flex", alignItems: "center", gap: 1 }}
                    >
                      <Avatar
                        src={option.profilePictureUrl || ""}
                        alt={option.name}
                        sx={{ width: 28, height: 28 }}
                      >
                        {option.name?.charAt(0)}
                      </Avatar>
                      <Box>
                        <Typography fontSize="14px" fontWeight={500}>
                          {option.name}
                        </Typography>
                        <Typography fontSize="12px" color="text.secondary">
                          {option.email}
                        </Typography>
                      </Box>
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Search Team Members"
                      size="small"
                      variant="outlined"
                      className="customInput"
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                          <>
                            {params.InputProps.startAdornment}
                            <InputAdornment position="start">
                              <SearchIcon
                                style={{ color: "#2D76DC", fontSize: "20px" }}
                              />
                            </InputAdornment>
                          </>
                        ),
                      }}
                    />
                  )}
                  PopperComponent={(props) => (
                    <Popper
                      {...props}
                      sx={{
                        padding: "8px",
                        "& .MuiAutocomplete-listbox": {
                          padding: "5px",
                          border: "1px solid #DEDFE5",
                          borderRadius: "8px",
                          "& li": {
                            backgroundColor: "#FFFFFF",
                            padding: "8px",
                            borderRadius: "8px",
                            cursor: "pointer",
                            transition: "background-color 0.3s ease",
                          },
                          "& li:hover": {
                            backgroundColor: "#0047AB",
                            color: "#FFFFFF",
                          },
                        },
                      }}
                    />
                  )}
                  disableClearable
                />

                {/* Tagged Members List */}
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 1,
                    marginTop: "15px",
                  }}
                >
                  {taggedMembers.map((member) => (
                    <Chip
                      key={member.id}
                      avatar={
                        <Avatar src={member.profilePictureUrl || ""}>
                          {member.name?.charAt(0)}
                        </Avatar>
                      }
                      label={member.name}
                      onDelete={() => removeTaggedMember(member)}
                      deleteIcon={<CloseIcon />}
                      className="taggedMembers-cards"
                    />
                  ))}
                </Box>
              </Box>
            )}
          </Grid>

          <Grid
            pl={{ xs: 0, md: 2 }}
            pr={{ xs: 0, md: 2 }}
            sx={{
              display: "flex",
              flexDirection: "column",
              paddingLeft: { xs: "0px !important", md: "24px !important" },
              paddingRight: { xs: "0px !important", md: undefined },
              minHeight: { md: "320px" },
            }}
            item
            xs={12}
            md={6}
            sm={12}
          >
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={1} flexWrap="wrap">
              <Typography variant="body2" color="#95919D" sx={{ mb: { xs: 1, sm: 0 } }}>
                Result Generated
              </Typography>
              <Box display="flex" gap={1} alignItems="center" flexWrap="wrap">
                {variations.map((_, i) => (
                  <Chip
                    key={i}
                    size="small"
                    label={`Variation ${i + 1}`}
                    onClick={() => handleTabChange(i)}
                    onDelete={variations.length > 1 ? () => handleDeleteVariation(i) : undefined}
                    deleteIcon={variations.length > 1 ? <CloseIcon style={{ fontSize: 14 }} /> : undefined}
                    sx={{
                      height: "28px",
                      backgroundColor: activeTab === i ? "#0047AB" : "#E7F1FF",
                      color: activeTab === i ? "#FFF" : "#0047AB",
                      fontWeight: activeTab === i ? 600 : 400,
                      cursor: "pointer",
                      "& .MuiChip-deleteIcon": {
                        color: activeTab === i ? "#FFF" : "#0047AB",
                        "&:hover": { color: activeTab === i ? "#e0e0e0" : "#003580" }
                      },
                      "&:hover": {
                        backgroundColor: activeTab === i ? "#003580" : "#d0e4ff",
                      }
                    }}
                  />
                ))}
                {variations.length < 3 && (
                  <Button
                    size="small"
                    variant="text"
                    onClick={handleAddVariation}
                    sx={{ textTransform: "none", color: "#0047AB", fontWeight: 600, minWidth: "auto", px: 1 }}
                  >
                    + Add
                  </Button>
                )}
              </Box>
            </Box>
            {/* Editor fills all remaining vertical space */}
            <Box sx={{ flex: 1, display: "flex", flexDirection: "column", minHeight: "200px" }}>
              <EditorBox value={editorValue} onChange={handleEditorValueChange} />
            </Box>
            <Typography
              variant="body2"
              sx={{ mt: 1, textAlign: { xs: "start", md: "end" } }}
              color="#95919D"
            >
              {(() => {
                const composition = getStrictestComposition(editorValue);
                return `Remaining: ${composition.remainingCharacters} / ${composition.maxBaseCharacters} (${composition.platformKey.toUpperCase()} limit after suffix)`;
              })()}
            </Typography>
          </Grid>
        </Grid>

        {/* Categories Input */}

        <Box className="buttons-container">
          {/* Action Buttons */}
          <Box className="actionButtons">
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: { xs: "space-evenly", sm: "flex-start" }, width: { xs: "100%", sm: "auto" }, gap: { xs: 0, sm: "4px" } }}>
              <IconButton
                color="primary"
                sx={{ padding: "8px 8px 8px 0px !important" }}
                onClick={() => {
                  setOpen(true);
                  setActiveButton("image");
                }}
              >
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 44 44"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className={activeButton === "image" ? "tagClicked" : undefined}
                >
                  <rect width="44" height="44" rx="8" fill="#F4F0FF" />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M27.0422 20.582C25.0977 20.582 24.1254 20.582 23.5213 19.9779C22.9172 19.3738 22.9172 18.4016 22.9172 16.457C22.9172 14.5125 22.9172 13.5402 23.5213 12.9361C24.1254 12.332 25.0977 12.332 27.0422 12.332C28.9868 12.332 29.9591 12.332 30.5631 12.9361C31.1672 13.5402 31.1672 14.5125 31.1672 16.457C31.1672 18.4016 31.1672 19.3738 30.5631 19.9779C29.9591 20.582 28.9868 20.582 27.0422 20.582ZM27.7297 14.6237C27.7297 14.244 27.4219 13.9362 27.0422 13.9362C26.6625 13.9362 26.3547 14.244 26.3547 14.6237V15.7695H25.2089C24.8292 15.7695 24.5214 16.0773 24.5214 16.457C24.5214 16.8367 24.8292 17.1445 25.2089 17.1445H26.3547V18.2904C26.3547 18.6701 26.6625 18.9779 27.0422 18.9779C27.4219 18.9779 27.7297 18.6701 27.7297 18.2904V17.1445H28.8756C29.2553 17.1445 29.5631 16.8367 29.5631 16.457C29.5631 16.0773 29.2553 15.7695 28.8756 15.7695H27.7297V14.6237Z"
                    fill="#0047AB"
                  />
                  <path
                    d="M31.1675 22.1384C31.1661 23.4855 31.1558 24.6305 31.0793 25.57C30.9905 26.6602 30.8084 27.5712 30.401 28.3278C30.2213 28.6616 30.0005 28.9604 29.7316 29.2293C28.9686 29.9923 27.9965 30.3379 26.7645 30.5036C25.5609 30.6654 24.0183 30.6654 22.0499 30.6654H21.9521C19.9837 30.6654 18.4411 30.6654 17.2375 30.5036C16.0056 30.3379 15.0335 29.9923 14.2704 29.2293C13.594 28.5528 13.2447 27.7109 13.0589 26.6665C12.8764 25.6405 12.8431 24.3641 12.8361 22.779C12.8344 22.3759 12.8344 21.9494 12.8344 21.4996V21.4498C12.8343 19.4814 12.8343 17.9388 12.9962 16.7352C13.1618 15.5032 13.5074 14.5311 14.2704 13.7681C15.0335 13.0051 16.0056 12.6595 17.2375 12.4938C18.3079 12.3499 19.685 12.334 21.3612 12.3322C21.7144 12.3319 22.001 12.6184 22.001 12.9716C22.001 13.3248 21.7143 13.611 21.3611 13.6113C19.6612 13.6131 18.3962 13.6286 17.4079 13.7615C16.3178 13.9081 15.6606 14.1868 15.1749 14.6726C14.6891 15.1583 14.4104 15.8155 14.2638 16.9056C14.1148 18.0141 14.1134 19.4708 14.1134 21.4987C14.1134 21.7464 14.1134 21.9859 14.1137 22.2178L14.9674 21.4708C15.7444 20.7909 16.9156 20.8299 17.6457 21.56L21.3036 25.2179C21.8896 25.8039 22.8121 25.8838 23.4901 25.4073L23.7444 25.2286C24.7201 24.5429 26.0402 24.6223 26.9266 25.4201L29.3402 27.5923C29.5831 27.0821 29.7274 26.4118 29.8044 25.4661C29.877 24.5751 29.887 23.4929 29.8884 22.1384C29.8888 21.7852 30.1749 21.4987 30.5282 21.4987C30.8814 21.4987 31.1678 21.7852 31.1675 22.1384Z"
                    fill="#ABC8F0"
                  />
                </svg>
              </IconButton>
              <input
                type="file"
                accept="image/*"
                multiple
                hidden
                id="modal-device-upload"
                onChange={(e) => {
                  const files = Array.from(e.target.files);
                  handleImageUploader(files);
                }}
                style={{ display: "none" }}
              />
              <IconButton
                color="primary"
                sx={{ padding: "8px 8px 8px 0px !important" }}
                onClick={() => {
                  setOpenVideoModal(true);
                  setActiveButton("video");
                }}
              >
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 44 44"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className={activeButton === "video" ? "tagClicked" : undefined}
                >
                  <rect width="44" height="44" rx="8" fill="#F4F0FF" />
                  <path
                    d="M12.8333 20.541C12.8333 17.5275 12.8333 16.0207 13.6655 15.0066C13.8179 14.8209 13.9882 14.6507 14.1738 14.4983C15.188 13.666 16.6947 13.666 19.7083 13.666C22.7218 13.666 24.2285 13.666 25.2427 14.4983C25.4284 14.6507 25.5986 14.8209 25.751 15.0066C26.5833 16.0207 26.5833 17.5275 26.5833 20.541V21.4577C26.5833 24.4712 26.5833 25.978 25.751 26.9921C25.5986 27.1778 25.4284 27.348 25.2427 27.5004C24.2285 28.3327 22.7218 28.3327 19.7083 28.3327C16.6947 28.3327 15.188 28.3327 14.1738 27.5004C13.9882 27.348 13.8179 27.1778 13.6655 26.9921C12.8333 25.978 12.8333 24.4712 12.8333 21.4577V20.541Z"
                    fill="#ABC8F0"
                  />
                  <path
                    d="M26.5833 18.7082L27.1867 18.4064C28.9705 17.5146 29.8623 17.0686 30.5145 17.4717C31.1666 17.8747 31.1666 18.8718 31.1666 20.8661V21.1336C31.1666 23.1279 31.1666 24.125 30.5145 24.528C29.8623 24.9311 28.9705 24.4851 27.1867 23.5933L26.5833 23.2915V18.7082Z"
                    fill="#0047AB"
                  />
                  <path
                    d="M20.3959 18.709C20.3959 18.3293 20.0881 18.0215 19.7084 18.0215C19.3287 18.0215 19.0209 18.3293 19.0209 18.709V20.3132H17.4167C17.0371 20.3132 16.7292 20.621 16.7292 21.0007C16.7292 21.3803 17.0371 21.6882 17.4167 21.6882H19.0209V23.2923C19.0209 23.672 19.3287 23.9798 19.7084 23.9798C20.0881 23.9798 20.3959 23.672 20.3959 23.2923V21.6882H22.0001C22.3798 21.6882 22.6876 21.3803 22.6876 21.0007C22.6876 20.621 22.3798 20.3132 22.0001 20.3132H20.3959V18.709Z"
                    fill="#0047AB"
                  />
                </svg>
              </IconButton>
              <input
                id="video-upload-input"
                type="file"
                accept="video/*"
                multiple
                onChange={handleVideoUpload}
                style={{ display: "none" }}
              />
              {/*<IconButton
                sx={{ padding: "8px 8px 8px 0px !important" }}
                color="primary"
                onClick={() => {
                  setIsTaggingVisible(!isTaggingVisible);
                  fetchAllUsers();
                  setActiveButton("tagging");
                }}
              >
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 44 44"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className={activeButton === "tagging" ? "tagClicked" : undefined}
                >
                  <rect width="44" height="44" rx="8" fill="#F4F0FF" />
                  <circle
                    cx="21.9999"
                    cy="15.5007"
                    r="3.66667"
                    fill="#0047AB"
                  />
                  <path
                    d="M27.5868 23.7779C27.1974 23.7493 26.7196 23.7493 26.1249 23.7493C24.6125 23.7493 23.8563 23.7493 23.3864 24.2192C22.9166 24.689 22.9166 25.4453 22.9166 26.9577C22.9166 28.0268 22.9166 28.718 23.0826 29.1974C22.7306 29.2316 22.3689 29.2493 21.9999 29.2493C18.4561 29.2493 15.5833 27.6077 15.5833 25.5827C15.5833 23.5576 18.4561 21.916 21.9999 21.916C24.3956 21.916 26.4846 22.6662 27.5868 23.7779Z"
                    fill="#ABC8F0"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M26.1251 30.1667C24.6127 30.1667 23.8564 30.1667 23.3866 29.6968C22.9167 29.227 22.9167 28.4708 22.9167 26.9583C22.9167 25.4459 22.9167 24.6897 23.3866 24.2198C23.8564 23.75 24.6127 23.75 26.1251 23.75C27.6375 23.75 28.3937 23.75 28.8636 24.2198C29.3334 24.6897 29.3334 25.4459 29.3334 26.9583C29.3334 28.4708 29.3334 29.227 28.8636 29.6968C28.3937 30.1667 27.6375 30.1667 26.1251 30.1667ZM26.6598 25.5324C26.6598 25.2371 26.4204 24.9977 26.1251 24.9977C25.8298 24.9977 25.5904 25.2371 25.5904 25.5324V26.4236H24.6992C24.4038 26.4236 24.1644 26.663 24.1644 26.9583C24.1644 27.2537 24.4038 27.4931 24.6992 27.4931H25.5904V28.3843C25.5904 28.6796 25.8298 28.919 26.1251 28.919C26.4204 28.919 26.6598 28.6796 26.6598 28.3843V27.4931H27.551C27.8463 27.4931 28.0857 27.2537 28.0857 26.9583C28.0857 26.663 27.8463 26.4236 27.551 26.4236H26.6598V25.5324Z"
                    fill="#0047AB"
                  />
                </svg>
              </IconButton>*/}

              {/* Attachment button â€" admin only */}
              {isAdmin && (
                <>
                  <IconButton
                    component="label"
                    sx={{ padding: "8px 8px 8px 0px !important" }}
                    color="primary"
                  >
                    <Box
                      sx={{
                        width: 32, height: 32, borderRadius: "8px",
                        backgroundColor: "#F4F0FF",
                        display: "flex", alignItems: "center", justifyContent: "center",
                      }}
                    >
                      <AttachFileIcon sx={{ color: "#0047AB", fontSize: 18 }} />
                    </Box>
                    <input
                      type="file"
                      accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv"
                      multiple
                      hidden
                      onChange={handleAttachmentUpload}
                    />
                  </IconButton>
                </>
              )}
            </Box>

            {/* Allow Edit toggle - admin only, right-aligned */}
            {isAdmin && (
              <>
                <Box sx={{ display: { xs: "none", sm: "block" }, width: "1px", height: "28px", backgroundColor: "#E0E0E0", mx: 1.5, ml: "auto", flexShrink: 0 }} />
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, px: 1.5, py: 0.75, backgroundColor: "#F8F6FD", borderRadius: "10px", width: { xs: "100%", sm: "auto" } }}>
                  <Typography fontSize="12px" color="#5C5B5D" sx={{ whiteSpace: "nowrap" }}>
                    Allow employees to edit caption
                  </Typography>
                  <Switch
                    checked={allowEdit}
                    onChange={(e) => setAllowEdit(e.target.checked)}
                    size="small"
                    color="primary"
                  />
                </Box>
              </>
            )}
          </Box>

          {/* Footer Buttons */}
          <Box className="footer-buttons" sx={{ display: "flex", width: { xs: "100%", sm: "auto" }, ml: { sm: "auto" } }}>
            {isEditMode ? (
              <>
                {onEditCancel && (
                  <Button onClick={onEditCancel} className="cancelButton" disabled={loading}>
                    Cancel
                  </Button>
                )}
                <Button
                  className={editorValue.trim() ? "postButton" : "postButtonDisabled"}
                  onClick={handleSaveEdit}
                  disabled={!editorValue.trim() || loading}
                >
                  Save Changes
                </Button>
              </>
            ) : (
              <>
                {isFormDirty && (
                  <Button onClick={() => handleDiscard()} className="cancelButton" disabled={loading}>
                    Cancel
                  </Button>
                )}
                <Button
                  className={editorValue.trim() ? "cancelButton" : "postButtonDisabled"}
                  onClick={() => setIsScheduleDialogOpen(true)}
                  disabled={!editorValue.trim() || loading}
                  sx={{ backgroundColor: "#F0F4FF", color: "#2D76DC", "&:hover": { backgroundColor: "#E0E9FF" } }}
                >
                  Schedule
                </Button>
                <Button
                  className={editorValue.trim() ? "postButton" : "postButtonDisabled"}
                  onClick={handlePost}
                  disabled={!editorValue.trim() || loading}
                >
                  Publish Now
                </Button>
              </>
            )}
          </Box>
        </Box>

        <Dialog
          elevation={0}
          open={isScheduleDialogOpen}
          maxWidth="sm"
          PaperProps={{
            sx: {
              width: { xs: "90vw", sm: "500px", md: "600px" },
              p: 0,
              m: 0,
              borderRadius: 2,
            },
          }}
          onClose={() => setIsScheduleDialogOpen(false)}
        >
          <Box sx={{ backgroundColor: "#f6f3ff", height: "auto", pb: 2 }}>
            {/* Header */}
            <Box
              bgcolor={"#ffffff"}
              boxShadow={"0px 4px 20px rgba(236, 236, 236, 0.25)"}
              display="flex"
              padding={2}
              justifyContent="space-between"
              alignItems="center"
            >
              <Box display="flex" flexDirection="column">
                <Typography
                  variant="h6"
                  color="rgba(59, 59, 59, 1)"
                  fontWeight={500}
                  fontSize="20px"
                >
                  Schedule this Post
                </Typography>
                <Typography variant="body2" color="#95919D" fontSize="13px" mt={0.5}>
                  Select the date and time when you want this post to be visible on the timeline.
                </Typography>
              </Box>
              <IconButton
                sx={{ width: "24px", height: "24px" }}
                onClick={() => setIsScheduleDialogOpen(false)}
              >
                <CloseIcon sx={{ color: "rgba(138, 138, 138, 1)" }} />
              </IconButton>
            </Box>

            {/* Date & Time Fields */}
            <Box display={"flex"} flexWrap={"wrap"}>
              {/* Date */}
              <Grid item xs={6} sx={{ padding: "30px", position: "relative" }}>
                <Typography variant="body2" color="#95919D" mb={1}>
                  Select Date
                </Typography>
                <TextField
                  fullWidth
                  value={formatDateForDisplay(scheduleDate)}
                  variant="standard"
                  onClick={() => dateInputRef.current?.showPicker()}
                  InputProps={{
                    readOnly: true,
                    startAdornment: (
                      <InputAdornment position="start">
                        <label htmlFor="schedule-date-picker">
                          <CalendarMonthOutlinedIcon
                            sx={{ color: "#1976d2", cursor: "pointer" }}
                          />
                        </label>
                      </InputAdornment>
                    ),
                  }}
                />
                <input
                  type="date"
                  id="schedule-date-picker"
                  ref={dateInputRef}
                  value={scheduleDate}
                  min={new Date().toISOString().split("T")[0]}
                  onChange={(e) => setScheduleDate(e.target.value)}
                  style={{
                    position: "absolute",
                    top: 50,
                    left: 0,
                    opacity: 0,
                    width: 0,
                    height: 0,
                    pointerEvents: "auto",
                  }}
                />
              </Grid>

              {/* Time */}
              <Grid item xs={6} sx={{ padding: "30px", position: "relative" }}>
                <Typography variant="body2" color="#95919D" mb={1}>
                  Select Time
                </Typography>
                <TextField
                  fullWidth
                  value={scheduleTime}
                  variant="standard"
                  onClick={() => timeInputRef.current?.showPicker()}
                  InputProps={{
                    readOnly: true,
                    startAdornment: (
                      <InputAdornment position="start">
                        <label htmlFor="schedule-time-picker">
                          <AccessTimeIcon
                            sx={{ color: "#1976d2", cursor: "pointer" }}
                          />
                        </label>
                      </InputAdornment>
                    ),
                  }}
                />
                <input
                  type="time"
                  id="schedule-time-picker"
                  ref={timeInputRef}
                  value={scheduleTime}
                  onChange={(e) => setScheduleTime(e.target.value)}
                  style={{
                    position: "absolute",
                    top: 50,
                    left: 0,
                    opacity: 0,
                    width: 0,
                    height: 0,
                    pointerEvents: "auto",
                  }}
                />
              </Grid>
            </Box>

            {/* Footer Buttons */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
                px: 3,
              }}
            >
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => setIsScheduleDialogOpen(false)}
                disabled={loading}
                sx={{ textTransform: "none" }}
              >
                Cancel
              </Button>
              {loading ? (
                <CircularProgress size="30px" />
              ) : (
                <Button
                  variant="contained"
                  onClick={() => {
                    if (!scheduleDate || !scheduleTime) {
                      toast.error("Please select both date and time");
                      return;
                    }
                    setIsScheduleDialogOpen(false);
                    handlePost();
                  }}
                  disabled={!scheduleDate || !scheduleTime}
                  sx={{
                    backgroundColor: "#2D76DC",
                    textTransform: "none",
                    "&:hover": { backgroundColor: "#1c5db8" },
                  }}
                >
                  Schedule
                </Button>
              )}
            </Box>
          </Box>
        </Dialog>

        <Dialog
          open={addCategoryDialogOpen}
          onClose={() => { setAddCategoryDialogOpen(false); setNewCategoryDialogInput(""); }}
          maxWidth="xs"
          fullWidth
          PaperProps={{ sx: { borderRadius: "16px", padding: "8px" } }}
        >
          <DialogTitle sx={{ fontWeight: 500, fontSize: "18px" }}>Add New Category</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              fullWidth
              size="small"
              placeholder="Category name"
              value={newCategoryDialogInput}
              onChange={(e) => setNewCategoryDialogInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") handleAddNewCategory(newCategoryDialogInput);
              }}
              sx={{ mt: 1 }}
            />
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button onClick={() => { setAddCategoryDialogOpen(false); setNewCategoryDialogInput(""); }} color="inherit">
              Cancel
            </Button>
            <Button
              onClick={() => handleAddNewCategory(newCategoryDialogInput)}
              variant="contained"
              disabled={!newCategoryDialogInput.trim() || categoryCreating}
              sx={{ backgroundColor: "#0047AB", borderRadius: "8px", textTransform: "none" }}
            >
              {categoryCreating ? "Adding..." : "Add"}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={discard}
          onClose={() => setDiscard(false)}
          maxWidth="xs"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: "20px",
              padding: "24px",
              position: "relative",
            },
          }}
        >
          {/* Close Icon */}
          <IconButton
            onClick={() => setDiscard(false)}
            sx={{ position: "absolute", top: 12, right: 12 }}
          >
            <CloseIcon sx={{ color: "#000" }} />
          </IconButton>

          {/* Title */}
          <DialogTitle
            sx={{
              fontWeight: "500",
              color: "#3B3B3B",
              fontSize: "24px",
              p: 0,
              mb: 1,
            }}
          >
            Discard Post?
          </DialogTitle>

          {/* Subtitle */}
          <DialogContent sx={{ px: 0 }}>
            <Typography
              sx={{
                color: "#95919D",
                fontSize: "16px",
                fontWeight: 400,
                width: "90%",
              }}
            >
              You have unsaved changes. Are you sure you want to cancel and
              discard this post?
            </Typography>
          </DialogContent>

          {/* Buttons */}
          <DialogActions
            sx={{
              px: 0,
              pt: 4,
              display: "flex",
              justifyContent: "end",
              gap: 1,
            }}
          >
            <Button
              onClick={() => setDiscard(false)}
              sx={{
                backgroundColor: "#F4F0FF",
                color: "#0047AB",
                borderRadius: "8px",
                textTransform: "none",
                border: "1px solid #F4F0FF",
                px: 2,
                // py: 1,
                fontWeight: 500,
                fontSize: "16px",
                "&:hover": {
                  backgroundColor: "#ece9fd",
                },
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleConfirm}
              variant="contained"
              sx={{
                backgroundColor: "#0047AB",
                color: "#fff",
                borderRadius: "8px",
                textTransform: "none",
                px: 2,
                // py: 1,
                fontWeight: 500,
                fontSize: "16px",
                "&:hover": {
                  backgroundColor: "#002f8c",
                },
              }}
            >
              Confirm
            </Button>
          </DialogActions>
        </Dialog>

        {open && (
          <ImageLibraryModal
            open={open}
            onClose={() => setOpen(false)}
            onConfirm={handleImageUploader}
          />
        )}
        {openVideoModal && (
          <VideoLibraryModal
            open={openVideoModal}
            onClose={() => setOpenVideoModal(false)}
            onConfirm={handleVideoConfirm}
          />
        )}
        {/* {activities && ( */}
        <ActivitiesPopup open={activities} onClose={handleClose} />
        {/* )} */}
        <StatusPopup
          open={showGeneratingPopup}
          onClose={() => setShowGeneratingPopup(false)}
        />
      </Card>
    </>
  );
};

export default TextEditor;

